import { EditSelect, IEditSelectProps } from "Components";
import { observer } from "mobx-react-lite";
import { PropsWithChildren } from "react";

export const ThemedEditSelect = observer((props: PropsWithChildren<IEditSelectProps>) => {
    return <EditSelect {...props} />;
});
